export const memberContractsReportLocation =
  "/reports/exchbusiness/membercontracts";
